import axios from '../../axios';

const path = 'notifications';

const service = {
  async clearAllNotifications() {
    return axios({ method: 'put', url: `${path}/clearAll` });
  },

  async clearNotification(id) {
    return axios({ method: 'put', url: `${path}/${id}/clear` });
  },

  async snoozeAllNotifications() {
    return axios({ method: 'put', url: `${path}/snoozeAll` });
  },

  async snoozeNotification(id) {
    return axios({ method: 'put', url: `${path}/${id}/snooze` });
  },

  async getNotifications(params) {
    return axios({ method: 'get', url: `${path}`, params });
  },

  async fetchNotification(id, params) {
    return axios({ method: 'get', url: `${path}/${id}`, params });
  }
};

export default service;
